import React from "react";
import PropTypes from "prop-types";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import MDModal from "../../MDModal";
import MDButton from "../../MDButton";


const AlertComponent = (props) => {
    return (
        <MDModal
            open={props.open}
            footer={null}
            onClose={props.onCancel}
            title="Alert"
            maxWidth="500px"
            width="500px"
        >
            <Stack mb={2}>
                {props.message}
            </Stack>
        </MDModal>
    )
};

AlertComponent.defaultProps = {
    item: null,
    message: "Are you sure you want to delete?",
    showButtons: true
}
AlertComponent.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    open: PropTypes.bool,
    item: PropTypes.object,
    message: PropTypes.string,
    saving: PropTypes.bool,
    errorMessage: PropTypes.string,
    showButtons: PropTypes.bool
};

export default AlertComponent;